// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateDuplicatePinPlateCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_DUPLICATE_PIN_PLATE_CRITERIA,
    value
});

export const resetCriteria = dealers => ({
    dealers,
    type: actions.RESET_DUPLICATE_PIN_PLATE_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/action-creators/criteria.js